import { createColumnHelper } from '@tanstack/react-table';

import i18n from '@/core/i18n';
import { cn } from '@/lib/utils';

import { CsvImportProjectError, ProjectErrorField } from '../../types';

const columnHelper = createColumnHelper<CsvImportProjectError>();

const ERROR_FIELD_LABELS: Record<ProjectErrorField, string> = {
  [ProjectErrorField.NAME]: 'authenticated.onboarding.projects:importModal.errors.invalidName',
  [ProjectErrorField.CLIENT]: 'authenticated.onboarding.projects:importModal.errors.invalidClient',
};

export const getErrorColumns = () => [
  columnHelper.accessor('name', {
    header: i18n.t('authenticated.onboarding.projects:importModal.projectName'),
    cell: ({ row, getValue }) => {
      const hasError = row.original.errorFields?.includes(ProjectErrorField.NAME);
      const value = getValue();
      if (!value) {
        return (
          <span className="text-sm text-muted-foreground">
            {i18n.t('authenticated.onboarding.projects:importModal.emptyValue')}
          </span>
        );
      }
      return <span className={cn('text-sm', hasError && 'text-destructive')}>{value}</span>;
    },
  }),
  columnHelper.accessor('clientName', {
    header: i18n.t('authenticated.onboarding.projects:importModal.client'),
    cell: ({ row, getValue }) => {
      const hasError = row.original.errorFields?.includes(ProjectErrorField.CLIENT);
      const value = getValue();
      if (!value) {
        return (
          <span className="text-sm text-muted-foreground">
            {i18n.t('authenticated.onboarding.projects:importModal.emptyValue')}
          </span>
        );
      }
      return <span className={cn('text-sm', hasError && 'text-destructive')}>{value}</span>;
    },
  }),
  columnHelper.display({
    id: 'reason',
    header: i18n.t('authenticated.onboarding.projects:importModal.errors.reason'),
    cell: ({ row }) => {
      const errorFields = row.original.errorFields ?? [];
      if (errorFields.length === 0) return null;

      const reasonText = errorFields.map(field => i18n.t(ERROR_FIELD_LABELS[field])).join('; ');

      return <span className="text-sm text-destructive">{reasonText}</span>;
    },
  }),
];
